function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import React, { useState } from 'react';
import * as stylex from "@stylexjs/stylex";
import Table from "nood-comp/src/comp/data/table/Table";
import { queryStringMod } from "nood-comp/src/util/converters/converters";
import ElapsedTime from "nood-comp/src/util/date/ElapsedTime";
import Circle from "nood-comp/src/comp/ui/circle/Circle";
export default function EventCategories(props) {
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    keyword = _useState2[0],
    setKeyword = _useState2[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Table, {
    key: "table-event-categories",
    useQuery: true,
    data_source: keyword ? "/event-categories?search=".concat(encodeURIComponent(keyword)) : "/event-categories",
    rowPadding: 5,
    paging: {
      per_page: 10,
      sorters: [{
        property: 'hierarchy',
        isAsc: true
      }]
    },
    cols: [{
      label: "",
      width: 50,
      content: function content(obj, idx) {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            display: "inline-flex",
            gap: 5,
            alignItems: "center"
          }
        }, obj.emoji && /*#__PURE__*/React.createElement("span", {
          style: {
            fontSize: 20
          }
        }, obj.emoji), obj.accent_color && /*#__PURE__*/React.createElement(Circle, {
          size: 10,
          backgroundColor: obj.accent_color
        }));
      }
    }, {
      property: "name",
      label: "Name",
      icon: "tag",
      filterType: "text",
      to: function to(obj, idx) {
        return queryStringMod({
          "do": "view",
          id: obj.id
        });
      }
    }, /*{property: `parent.name`, label: `Parent`},*/
    {
      property: "description",
      label: "Description"
    }, {
      label: "",
      width: 70,
      content: function content(obj, idx) {
        return /*#__PURE__*/React.createElement(ElapsedTime, {
          key: obj.id,
          datetime: obj.created_dt
        });
      }
    }]
  }));
}

// @ts-ignore